import { render, staticRenderFns } from "./SettingMenuNew.vue?vue&type=template&id=50468136&scoped=true"
import script from "./SettingMenuNew.vue?vue&type=script&lang=js"
export * from "./SettingMenuNew.vue?vue&type=script&lang=js"
import style0 from "./SettingMenuNew.vue?vue&type=style&index=0&id=50468136&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50468136",
  null
  
)

export default component.exports